import { css } from 'styled-components'

import type { TierRank } from '../model/tier-rank'

export const tierRankGradientCss: Record<TierRank, string> = {
  gold: 'linear-gradient(90deg, #ffee82 17.72%, #ffe53e 39.71%, #ffc301 65.31%, #ffa201 90.1%)',
  diamond:
    'linear-gradient(83.37deg, #ffb9ff 8.47%, #fe89fe 35.96%, #d15cfe 60.75%, #8e1fea 89.02%)',
  platinum:
    'linear-gradient(83.14deg, #bcfffe 8.73%, #57ffff 37.97%, #20cbcd 64.32%, #068a85 94.38%)',
  elite:
    'linear-gradient(90deg, #ff6c6b 17.72%, #ff3333 39.71%, #cb1e1e 65.31%, #971b1a 90.1%)',
}

export const tierRankTextGradientCss = (tier: TierRank) => css`
  background: ${tierRankGradientCss[tier]}, #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`
